import { useQuery } from '@apollo/client'
import {
  ONBOARDING_STATUS_QUERY,
  OnboardingStatusData
} from 'src/api/onboarding/queries/onboardingStatus'

export function useOnboardingStatus() {
  const { data, loading, error, refetch } = useQuery<OnboardingStatusData>(
    ONBOARDING_STATUS_QUERY,
    {
      fetchPolicy: 'cache-first'
    }
  )

  const calculateProgress = () => {
    if (!data?.onboardingStatus) return 0

    const completedSteps = data.onboardingStatus.filter(step => step.completed)
      .length

    const totalSteps = data.onboardingStatus.length

    if (totalSteps === 0) return 0

    return Math.round((completedSteps / totalSteps) * 100)
  }

  return {
    onboardingStatus: data?.onboardingStatus ?? [],
    loading,
    error,
    progress: calculateProgress(),
    refetch: () => refetch({ fetchPolicy: 'network-only' })
  }
}
